import { connect } from 'react-redux'
import { Button, Tooltip } from 'antd'
import { useHotKeys } from 'Hooks'
import { toggleTabLocked, setTableConfig } from 'Actions/explore'
import Feather from '@sysunite/react-feather'

TabLocker = ({ style, locked, toggleTabLocked, setTableConfig }) ->

  toggle = ->
    localStorage.setItem('tree-nav-tab-locked', !locked)
    toggleTabLocked()

  useHotKeys([{
    sequence: 'l'
    fn: toggle
    watchers: [locked]
  }])

  titleText = """
      Prevent automatic switching to another tab, both when clicking in this panel, and also in the graph panel.
    """

  <Tooltip title={titleText} mouseEnterDelay={1}>
    <Button
      onClick={toggle}
      data-testid="tablocker-#{if locked then 'locked' else 'unlocked'}"
      shape="circle"
      type={if locked then "primary" else "link"}
      icon={
        <Feather
          type={if locked then 'lock' else 'unlock'}
          strokeWidth={2}
        />
      }
    />
  </Tooltip>

mapStateToProps = ({ explore }) -> { locked: explore.tabIsLocked }

export default connect(mapStateToProps, { toggleTabLocked, setTableConfig })(TabLocker)



